import { Button } from 'primereact/button';
import { Tooltip } from 'primereact/tooltip';
import { classNames } from 'primereact/utils';

const StandardPageHeader = ({ title, refreshData, overrideClassNames }) => {
  return (
    <div className={classNames("pageHeader", overrideClassNames)}>
      <h1 className="pageTitle mb-2">{title}</h1>
      <Tooltip target=".refresh-tip-target" />
      <Button
        icon="pi pi-refresh"
        severity="secondary"
        outlined
        rounded
        className="refresh-tip-target"
        onClick={() => refreshData()}
        tooltip="Refresh data"
        tooltipOptions={{ showDelay: 1000, hideDelay: 100, position: "left" }}
      />
    </div>
  );
};

export default StandardPageHeader;